import StoreModuleService from '../StoreModuleService';
import { MODULE_NAME } from './const';

const buildGetterObject = (getter) => StoreModuleService.buildGetterObject(MODULE_NAME, getter);

// getters declarations
export const loading = buildGetterObject('loading');
export const processes = buildGetterObject('processes');
export const processById = buildGetterObject('processById');
export const allProcessNodes = buildGetterObject('allProcessNodes');

const getters = {
	[loading.getter]: ({ loading }) => loading,
	[processes.getter]: ({ processes }) => Object.values(processes).sort((a, b) => b.id - a.id),
	[processById.getter]:
		({ processes }) =>
		(id) =>
			processes[id],
	[allProcessNodes.getter]: ({ processes }) =>
		Object.values(processes)
			.map(({ nodes }) => nodes)
			.flat(),
};

export default getters;
